import Vue from 'vue';
import Vuex from 'vuex';
import VueAuthenticateInstance from '@/services/auth.js';

export default new Vuex.Store({
    state: {
        isAuthenticated: false,
        profile: {}
    },
    getters: {
        isAuthenticated() {
            return VueAuthenticateInstance.isAuthenticated();
        },
        profile(state) {
            return state.profile;
        }
    },
    mutations: {
        authenticate(state, payload) {
            state.isAuthenticated = payload.isAuthenticated;
        },
        profile(state, payload) {
            state.profile = payload;
        }
    },
    actions: {
        login(context, payload) {
            payload || {};
            return VueAuthenticateInstance.login(payload.user, payload.requestOptions).then(response => {
                if (response && response.status === 200 && response.data && response.data.status) {
                    context.commit('authenticate', {
                        isAuthenticated: VueAuthenticateInstance.isAuthenticated()
                    });
                    context.commit('profile', response.data.user);
                    return response;
                }
                return response ? response.response : null;
            }).catch(error => {
                return error ? error.response : null;
            });

        },
        logout(context, payload) {
            payload = payload || {};
            var notifyLogout = Promise.resolve();
            if (VueAuthenticateInstance.isAuthenticated() && !window.__isForceLoggingOut) {
                notifyLogout = Vue.axios.get(process.env.API_URL + '/auth/logout', {
                    meta: { loading: false, throwError: false }
                }).catch(function () {});
            }
            return notifyLogout.then(function () {
                return VueAuthenticateInstance.logout(payload.requestOptions).then(function () {
                    context.commit('authenticate', {
                        isAuthenticated: VueAuthenticateInstance.isAuthenticated()
                    });
                    context.commit('profile', {});
                });
            });
        },
        setProfile(context, payload) {
            payload = payload || {};
            if (context.getters.isAuthenticated) {
                return Vue.axios.get(process.env.API_URL + '/user/profile', payload.requestOptions).then(response => {
                    if (response && response.status === 200 && response.data && response.data.status) {
                        context.commit('profile', response.data.data);
                        return response;
                    }
                    return response ? response.response : null;
                });
            } else {
                context.commit('profile', {});
            }
        }

    }
})



// WEBPACK FOOTER //
// ./src/store.js